/**
 * Helpers for the GPC suggestion endpoint (POST /product/gpc-suggestions/batch).
 * Backend limits are guarded here so one bad row cannot make the endpoint
 * answer 422 for a whole block.
 */

export const GPC_SUGGESTION_BLOCK_SIZE = 100;

export function chunk(list, size) {
  const blocks = [];
  for (let i = 0; i < list.length; i += size) {
    blocks.push(list.slice(i, i + size));
  }
  return blocks;
}

/**
 * Build the request row for one product, or null when the endpoint would refuse it
 * (no id, id over 120 characters, GLN without 13 digits).
 */
export function buildSuggestionRequest(product) {
  const id = product?._id;
  const gln = product?.informationProvider;
  if (!id || String(id).length > 120 || !/^\d{13}$/.test(String(gln))) {
    return null;
  }

  const pi = product.productInformation || {};
  const variant = product.productPackagingHierarchy?.[0];
  const items = Array.isArray(variant) ? variant.filter(Boolean) : [];
  const unit =
    items.find(i => i.tradeItemUnitDescriptorCode === 'BASE_UNIT_OR_EACH') || items[0] || {};
  const gtin = unit.GTIN != null ? String(unit.GTIN) : undefined;
  const unitDescriptor = unit.tradeItemUnitDescriptorCode;
  const description = pi.tradeItemDescription || pi.productName;

  return {
    id: String(id),
    documentId: product.transactionId,
    gln: String(gln),
    brandName: pi.productBrandName ? String(pi.productBrandName).slice(0, 120) : undefined,
    description: description ? String(description).slice(0, 500) : undefined,
    gtin: gtin && gtin.length <= 14 ? gtin : undefined,
    unitDescriptor: unitDescriptor && unitDescriptor.length <= 40 ? unitDescriptor : undefined
  };
}
